import {Utils} from 'hasta-la-vista-ui-core'
import {AuthService, ContactUsService} from 'hasta-la-vista-middleware-api/service'
import {UAParser}	from 'ua-parser-js'
import MetaData from  '../../../mixins/meta-data.js'

export default {

	mixins: [MetaData],

	data() {
		return {
			isGuest: false,
			user: null,
			isActive: false,
			help: null,
			help_options: [
				{id: 1, name: 'I\'d Just Like to Leave a Message'},
				{id: 2, name: 'Browsing Movies'},
				{id: 3, name: 'Booking Tickets'},
				{id: 4, name: 'SK Clubs and Movie Cards'},
				{id: 5, name: 'SK Fan Club or MORvies Club Cancellation'}
			],
			isBrowsing: false,
			browsing_selected: null,
			browsing_options: [
				'Filters',
				'Trailers',
				'Cinema-Related Issues',
				'Movies Now Showing',
				'Movies Coming Soon',
				'Incorrect Information'
			],
			isTicketing: false,
			ticketing_movie_name: null,
			ticketing_selected: null,
			ticketing_options: [
				'Choosing Tickets',
				'Booking Multiple Tickets',
				'Booking Multiple Movies',
				'Payment',
				'Confirmation Email'
			],
			ticketing_date_day: null,
			ticketing_date_month: Utils.MonthMeta(),
			ticketing_date_month_selected: null,
			ticketing_date_year: null,
			ticketing_movie_time: ["08:00 - 10:00", "10:00 - 12:00", "12:00 - 14:00", "14:00 - 16:00", "16:00 - 18:00", "18:00 - 20:00", "20:00 - 22:00", "22:00 - 00:00"],
			ticketing_movie_time_selected: null,
			ticketing_cinema: null,
			ticketing_ticket_type: null,
			isClubLoyalty: false,
			club_loyalty_options: [
				'SK Club Movie Card',
				'Discovery Vitality Movie Benefit Card',
				'Edgars Club Movie Card',
				'Pick n Pay Card',
				'Standard Bank',
			],
			club_loyalty_selected: null,
			club_loyalty_struggles: [
				'Points and Reward',
				'Password Reset'
			],
			club_loyalty_struggles_selected: null,
			first_name: '',
			surname: '',
			email: '',
			mobile: '',
			contact_message: '',
			formData: {},
			ua_result: {
				browser: {name: null, version: null},
				device: {model: null, type: null, vendor: null},
				engine: {name: null, version: null},
				os: {name: null, version: null},
			},
			isSubsClub: false,
			loadingSubmit: false,
			successDialog: false,
			card_number: null,
			tmp_card_number: null,
			compiled_value: null,
			member_id: null,
			mobileNumber: null
		}
	},

	mounted() {
		AuthService.addObserver(this, AuthService.PROFILE_CHANGED, this.checkUser); // listen for changes to the user:
    	this.checkUser(); // get and set the user.
		window.scroll({top: 0, left: 0})
	},

	methods: {
		help_selected(selectOption) {
			this.isActive = true
			this.isMessage = false
			this.isBrowsing = false
			this.isTicketing = false
			this.isClubLoyalty = false
			this.isSubsClub = false
			switch (selectOption.id) {
				case 2:
					this.browsingActivation = selectOption.name
					this.isBrowsing = true
					this.isMessage = false
					this.isTicketing = false
					this.isClubLoyalty = false
					this.isSubsClub = false
					break
				case 3:
					this.ticketingValidation = selectOption.name
					this.isTicketing = true
					this.isMessage = false
					this.isBrowsing = false
					this.isClubLoyalty = false
					this.isSubsClub = false
					break
				case 4:
					this.isClubLoyalty = true
					this.isMessage = false
					this.isBrowsing = false
					this.isTicketing = false
					this.isSubsClub = false
					break
				case 5: 
					this.isSubsClub = true
					this.isMessage = false
					this.isBrowsing = false
					this.isTicketing = false
					this.isClubLoyalty = false
					break;
				default:
					this.helpValidation = selectOption.name
					this.isMessage = true
					this.isSubsClub = false
					this.isMessage = false
					this.isBrowsing = false
					this.isTicketing = false
					this.isClubLoyalty = false

					break;
			}
		},

		help_removed(removedOption) {
			this.isActive = false
			this.help = ''
			switch (removedOption.id) {
				case 2:
					this.isBrowsing = false
					break
				case 3:
					this.isTicketing = false
					break
				case 4:
					this.isClubLoyalty = false
					break
				case 5:
					this.isBrowsing = false
					this.isTicketing = false
					this.isSubsClub = true
					this.isClubLoyalty = true
				default:
					this.isMessage = false
					break;
			}
		},

		checkUser(){
	        AuthService.user().then( (user)=> {
	        	this.user = user
	        	this.isGuest = user.isGuest()
	        } )
   		},

   		setUser(){
            return AuthService.user().then((user)=> {
                this.user = user;
                this.isGuest = user.isGuest();
                if (!user.isGuest() && user.MembershipActivated === false && this.first_time) {
                    // this.cookieActive = false;
                    // this.first_time = false;
                } else {
                    // this.showUserActivation = false;
                }

                return this.user
            })
        },

		onSubmit() {
			this.loadingSubmit = true
			this.formData = {
				ContactType: "Message",
				Surname:this.isGuest ? this.surname : this.user.LastName, 
				FirstName:this.isGuest ? this.first_name : this.user.FirstName, 
				Email:this.isGuest ? this.email : this.user.Email, 
				Mobile:this.isGuest ? this.mobile : this.user.MobilePhone,
				Message:this.contact_message,
				UaResult: this.ua_result,
			}


			if(this.isTicketing) {
				this.formData = {
					ContactType: "Ticketing",
					Surname:this.isGuest ? this.surname : this.user.LastName, 
					FirstName:this.isGuest ? this.first_name : this.user.FirstName, 
					Email:this.isGuest ? this.email : this.user.Email, 
					Mobile:this.isGuest ? this.mobile : this.user.MobilePhone, 
					Message:this.contact_message, 
					UaResult: this.ua_result,
					TicketingSelected: this.ticketing_selected, 
					MovieName: this.ticketing_movie_name,
					DateDay: this.ticketing_date_day,
					DateMonth: this.ticketing_date_month_selected,
					DateYear: this.ticketing_date_year,
					MovieTime: this.ticketing_movie_time_selected,
					Cinema: this.ticketing_cinema,
					TicketType: this.ticketing_ticket_type
				}
			}

			if(this.isClubLoyalty) {
				this.formData = {
					ContactType: "ClubLoyalty",
					Surname:this.isGuest ? this.surname : this.user.LastName, 
					FirstName:this.isGuest ? this.first_name : this.user.FirstName, 
					Email:this.isGuest ? this.email : this.user.Email, 
					Mobile:this.isGuest ? this.mobile : this.user.MobilePhone, 
					Message:this.contact_message, 
					UaResult: this.ua_result,
					LoyaltySelected: this.club_loyalty_selected,
					Struggles: this.club_loyalty_struggles_selected
				}
			}

			if(this.isBrowsing) {
				this.formData = {
					ContactType: "Browsing",Surname:this.isGuest ? this.surname : this.user.LastName, 
					FirstName:this.isGuest ? this.first_name : this.user.FirstName, 
					Email:this.isGuest ? this.email : this.user.Email, 
					Mobile:this.isGuest ? this.mobile : this.user.MobilePhone,
					Message:this.contact_message,
					UaResult: this.ua_result,
					BrowsingSelected:this.browsing_selected
				}
			}

			if(this.isSubsClub) {
				this.formData = {
					ContactType: "FanClubCancellation", 
					Surname: this.surname,
					FirstName: this.first_name,
					Email: this.email,
					MemberId: this.member_id,
					CardNumber: this.card_number,
					CompiledValue: "|" + this.compiled_value + "|",
					Message: this.contact_message,
					MobileNumber: this.mobileNumber,
				}

				if(this.card_number != null || this.card_number != undefined) {
					if(this.card_number.length == 0) {
						this.formData.CardNumber = this.tmp_card_number
					}
				}
			}

			// console.log("formData", this.formData)
			Promise.resolve(ContactUsService.sendContactUs(this.formData)).then((result) => {
				this.loadingSubmit = false
				this.successDialog = true
				this.help_removed({id: 0, name: ''})
			}, (error)=> {
				this.loadingSubmit = false
			});
		}
	},

	created() {
		Promise.resolve(this.setUser()).then((user) => {

			if(user != null && user != undefined) {
				this.first_name = user.FirstName
				this.surname = user.LastName
				this.email = user.Email
				this.card_number = user.CardNumber
				this.tmp_card_number = user.CardNumber
				this.compiled_value = user.WorkZipCode
				this.member_id = user.MemberId
				this.mobileNumber = user.MobilePhone
			}

			if(this.$route.params != null && this.$route.params != undefined) {
				if(this.$route.params.type != null && this.$route.params != undefined) {
					if(this.$route.params.type == "cancellation") {
						this.help = {id: 5, name: 'SK Fan Club or MORvies Club Cancellation'}

						this.help_selected(this.help)
					}
				}
			}
			
			var parser = new UAParser();
			var ua_result = parser.getResult();

			this.ua_result.browser.name 	= ua_result.browser.name;
			this.ua_result.browser.version 	= ua_result.browser.version;

			this.ua_result.device.model 	= ua_result.device.model;
			this.ua_result.device.type 		= ua_result.device.type;
			this.ua_result.device.vendor 	= ua_result.device.vendor;

			this.ua_result.engine.name 		= ua_result.engine.name;
			this.ua_result.engine.version 	= ua_result.engine.version;

			this.ua_result.os.name 			= ua_result.os.name;
			this.ua_result.os.version 		= ua_result.os.version;

			this.metaTitle = 'Contact Us | South Africa\'s Largest Cinema Exhibitor'
			this.metaDescription = 'Browse the latest movies and book your tickets online. If you are interested in block bookings you can contact us directly. View our contact details.'			
		})
	}
}


// WEBPACK FOOTER //
// ./src/components/pages/contact-us/contact-us.js